import { useState } from "react";
import { Modal, Alert } from "react-bootstrap";
import { organizerDeleteGiftApi } from "../../api/api";

// Deleting is order-scoped: it removes every ticket of the invitation. The copy
// states the real count so the organizer is never surprised by the blast radius.
export default function GiftDeleteConfirm({ show, order, onHide, onDeleted }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const quantity = Number(order?.quantity || 0);
  const guestName = order?.giftLabel || order?.recipientName || "este invitado";

  const handleConfirm = async () => {
    if (!order?.orderId) return;
    setSubmitting(true);
    setError("");
    try {
      await organizerDeleteGiftApi(order.orderId);
      onDeleted?.();
      onHide?.();
    } catch (err) {
      setError(
        err?.response?.status === 409
          ? "La invitación ya fue utilizada y no se puede eliminar."
          : "No se pudo eliminar la invitación. Intentá de nuevo."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="gifts-especiales">
      <Modal.Header closeButton>
        <Modal.Title>Eliminar invitación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <p className="zoco-confirm-lead">
          {quantity > 1
            ? `Vas a eliminar las ${quantity} entradas de ${guestName}.`
            : `Vas a eliminar la entrada de ${guestName}.`}
        </p>
        <p className="zoco-confirm-sub">
          Esta acción no se puede deshacer y los QR dejan de funcionar.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="zoco-ticket-btn light"
          onClick={onHide}
          disabled={submitting}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="zoco-ticket-btn danger"
          onClick={handleConfirm}
          disabled={submitting}
        >
          {submitting ? "Eliminando…" : "Eliminar"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
